import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = {
  key: 2,
  class: "text-xs"
}
const _hoisted_5 = { key: 3 }
const _hoisted_6 = { key: 4 }
const _hoisted_7 = { key: 5 }
const _hoisted_8 = {
  key: 0,
  class: "font-bold"
}
const _hoisted_9 = {
  key: 1,
  style: {"font-size":"95%","font-style":"italic"}
}
const _hoisted_10 = {
  key: 2,
  style: {"font-size":"95%","font-style":"italic"}
}
const _hoisted_11 = { key: 6 }
const _hoisted_12 = { class: "font-bold" }
const _hoisted_13 = {
  key: 0,
  style: {"font-style":"italic"},
  class: "text-xs"
}
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { key: 1 }
const _hoisted_16 = { key: 7 }
const _hoisted_17 = { key: 8 }
const _hoisted_18 = /*#__PURE__*/_createTextVNode("Close")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_skeleton = _resolveComponent("el-skeleton")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_tag = _resolveComponent("el-tag")!
  const _component_order_source_tag = _resolveComponent("order-source-tag")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createBlock(_component_el_dialog, {
    modelValue: _ctx.dialogVisible,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.dialogVisible) = $event)),
    title: `Customer details`,
    width: "90%",
    top: "10vh"
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_el_button, {
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.close()))
      }, {
        default: _withCtx(() => [
          _hoisted_18
        ]),
        _: 1
      })
    ]),
    default: _withCtx(() => [
      (_ctx.isLoading)
        ? (_openBlock(), _createBlock(_component_el_skeleton, { key: 0 }))
        : (_openBlock(), _createBlock(_component_el_row, { key: 1 }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, {
                span: 24,
                class: "mb-3 font-italic flex justify-end"
              }, {
                default: _withCtx(() => [
                  _createElementVNode("p", null, "Email: " + _toDisplayString(_ctx.customerEmail), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 24,
                class: "mb-3 flex item-center"
              }, {
                default: _withCtx(() => [
                  _withDirectives(_createVNode(_component_el_table, {
                    data: _ctx.customers,
                    lazy: _ctx.isLoading,
                    stripe: "",
                    style: {"width":"100%"}
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.columns, (column) => {
                        return (_openBlock(), _createBlock(_component_el_table_column, {
                          key: column.dataIndex,
                          prop: column.dataIndex,
                          label: column.title,
                          "tooltip-effect": column.dataIndex,
                          "min-width": column.minWidth
                        }, {
                          default: _withCtx((scope) => [
                            (column.dataIndex === 'storeFinancialStatus')
                              ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                  (scope.row[column.dataIndex])
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                        _createVNode(_component_el_tag, { type: "success" }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                                          ]),
                                          _: 2
                                        }, 1024)
                                      ]))
                                    : _createCommentVNode("", true)
                                ]))
                              : (column.dataIndex === 'grandTotal')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.formatterDollars(scope.row[column.dataIndex])), 1))
                                : (column.dataIndex === 'transactionId')
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(scope.row[column.dataIndex]), 1))
                                  : (column.dataIndex === 'status')
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                        _createVNode(_component_el_tag, {
                                          type: _ctx.getOrderStatusColor(scope.row[column.dataIndex]),
                                          size: "small"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode(_toDisplayString(scope.row[column.dataIndex]), 1)
                                          ]),
                                          _: 2
                                        }, 1032, ["type"])
                                      ]))
                                    : (column.dataIndex === 'createdAt')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_ctx.formatTime(scope.row[column.dataIndex])), 1))
                                      : (column.dataIndex === 'items')
                                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(scope.row[column.dataIndex], (item, index) => {
                                              return (_openBlock(), _createElementBlock("div", {
                                                key: item._id
                                              }, [
                                                (item?.itemName)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(`${index + 1}. ${item.itemName}`), 1))
                                                  : _createCommentVNode("", true),
                                                (item?.variantTitle)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_9, " Variant: " + _toDisplayString(item.variantTitle), 1))
                                                  : _createCommentVNode("", true),
                                                (item?.sellerAmount)
                                                  ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(_ctx.formatterDollars(item.sellerAmount)), 1))
                                                  : _createCommentVNode("", true)
                                              ]))
                                            }), 128))
                                          ]))
                                        : (column.dataIndex === 'referenceId1')
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                                              _createElementVNode("p", _hoisted_12, _toDisplayString(scope.row[column.dataIndex]), 1),
                                              (scope.row?.store)
                                                ? (_openBlock(), _createElementBlock("span", _hoisted_13, [
                                                    (scope.row.store.appShopUrl)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_14, " Sub domain: " + _toDisplayString(scope.row.store.appShopUrl), 1))
                                                      : _createCommentVNode("", true),
                                                    (scope.row.store.domain)
                                                      ? (_openBlock(), _createElementBlock("p", _hoisted_15, " Domain: " + _toDisplayString(scope.row.store.domain), 1))
                                                      : _createCommentVNode("", true)
                                                  ]))
                                                : _createCommentVNode("", true)
                                            ]))
                                          : (column.dataIndex === 'source')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                _createVNode(_component_order_source_tag, {
                                                  source: scope.row[column.dataIndex]
                                                }, null, 8, ["source"])
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(scope.row[column.dataIndex]), 1))
                          ]),
                          _: 2
                        }, 1032, ["prop", "label", "tooltip-effect", "min-width"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["data", "lazy"]), [
                    [_directive_loading, _ctx.isLoading]
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["modelValue"]))
}